import { render, staticRenderFns } from "./InputMoney.vue?vue&type=template&id=56bf87ab&scoped=true"
import script from "./InputMoney.vue?vue&type=script&lang=js"
export * from "./InputMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bf87ab",
  null
  
)

export default component.exports